// @ts-ignore
import { ScatterplotLayer } from "@deck.gl/layers";

export const PoILayer = ({
    showPoi,
    poi,
    onHoverPoi,
    handleClick,
    focusedItem,
    isGeoFocused,
    brand,
}: any) => {
    if (!showPoi || !poi?.length) return [];

    const visualLayer = new ScatterplotLayer({
        id: "poi-layer-visual",
        data: poi,
        getPosition: (d: any) => [d.longitude, d.latitude],
        radiusUnits: "pixels",
        getRadius: (d: any) => (d.isSelected ? 7.5 : 5),
        getFillColor: (d: any) => {
            const isClicked = focusedItem?.type === 'poi' &&
                focusedItem?.data?.latitude === d.latitude &&
                focusedItem?.data?.longitude === d.longitude;
            const isHovered = brand?.latitude === d.latitude &&
                brand?.longitude === d.longitude;

            if (isClicked) {
                // Clicked state: #fff for normal POI, #A7BCFF for highlighted POI
                return d.isSelected ? [167, 188, 255, 255] : [255, 255, 255, 255];
            }

            if (isHovered) {
                // Hovered state: #fff for normal POI, #A7BCFF for highlighted POI
                return d.isSelected ? [167, 188, 255, 255] : [255, 255, 255, 255];
            }

            return d.filtered_out ? [175, 175, 175, 255] : d.isSelected ? [0, 48, 199, 255] : [174, 194, 255, 255];
        },
        stroked: true,
        lineWidthUnits: "pixels",
        getLineColor: (d: any) => {
            const isClicked = focusedItem?.type === 'poi' &&
                focusedItem?.data?.latitude === d.latitude &&
                focusedItem?.data?.longitude === d.longitude;
            const isHovered = brand?.latitude === d.latitude &&
                brand?.longitude === d.longitude;

            if (isClicked) {
                // Clicked state: #07206A for normal POI, #0030C7 for highlighted POI
                return d.isSelected ? [0, 48, 199, 255] : [7, 32, 106, 255];
            }

            if (isHovered) {
                // Hovered state: #8DA9FF for normal POI, #E3EAFF for highlighted POI
                return d.isSelected ? [227, 234, 255, 255] : [141, 169, 255, 255];
            }

            return d.filtered_out ? [69, 69, 69, 255] : d.isSelected ? [184, 201, 255, 255] : [7, 32, 106, 255];
        },
        getLineWidth: () => 1,
        updateTriggers: {
            getFillColor: [focusedItem, brand],
            getLineColor: [focusedItem, brand],
            getRadius: [focusedItem],
            getPosition: [poi.length]
        },
        pickable: false,
    });

    const interactionLayer = new ScatterplotLayer({
        id: "poi-layer-interaction",
        data: poi,
        getPosition: (d: any) => [d.longitude, d.latitude],
        radiusUnits: "pixels",
        getRadius: () => 15,
        getFillColor: () => [0, 0, 0, 0],
        stroked: false,
        pickable: true,
        onHover: (info: any) => {
            const { object, pixel } = info;
            if (object)
                onHoverPoi && !focusedItem.type && !isGeoFocused && onHoverPoi("poi", object ?? null, pixel);
            else onHoverPoi && !isGeoFocused && onHoverPoi("poi", null);
        },
        onClick: (info: any) => {
            const { object, pixel } = info;
            // Allow clicks even when there's a focused item or region, to enable switching between markers
            handleClick && object && handleClick("poi", object ?? null, pixel);
        },
        updateTriggers: {
            getPosition: [poi.length]
        },
    });

    return [visualLayer, interactionLayer];
};
